import { Component, OnInit } from '@angular/core';
import { Patient } from '../../domain/patient';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { LoggingService } from '../../services/logging-service/logging.service';
import { Router } from '@angular/router';
import { PatientDataService } from '../../services/patient-data/patient-data.service';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { MatSnackBar } from '@angular/material';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-portal-admin-patient-view',
  templateUrl: './portal-admin-patient-view.component.html',
  styleUrls: ['./portal-admin-patient-view.component.css']
})
export class PortalAdminPatientViewComponent implements OnInit {

  private patient: Patient;
  private previousAppointment: string;
  private documentLibrary: any;
  loaded: boolean;
  error: boolean;

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router, private patientData: PatientDataService,
    private loggingService: LoggingService, private snackBar: MatSnackBar, private userSession: UserSessionService) { }

  ngOnInit() {
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, "Patient Information", null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, true, true));

    // Get the patient for the view
    if (this.appConfigService.PatientId == undefined) {
      this.router.navigate(['app', 'admin', 'search']);
      return;
    }

    if (this.appConfigService.PatientId == 0) {
      this.router.navigate(['app', 'admin', 'search']);
      return;
    }

    this.patientData.getPatient(this.appConfigService.PatientId).subscribe((response => {
      this.patient = response.json();
      this.loggingService.log("Executed getPatient", this.appConfigService.LogToConsole);

      // Split the NHS Number to appear as it should
      this.patient.NHSNumber = this.patient.NHSNumber.substring(0, 3) + ' ' + this.patient.NHSNumber.substring(3, 6) + ' ' + this.patient.NHSNumber.substring(6, 10);

      // Get the previous appointment
      if (this.patient.CurrentPregnancy == undefined || this.patient.CurrentPregnancy == null) {
        this.loaded = true;
        return;
      }

      this.patientData.getPreviousAppointment(this.patient.CurrentPregnancy.PregnancyId).subscribe(result => {
        this.loggingService.log("Executed getPreviousAppointment", this.appConfigService.LogToConsole);
        this.previousAppointment = result.json();

        // Get the document library
        this.patientData.getLibrary().subscribe(result => {
          this.loggingService.log("Executed getLibrary", this.appConfigService.LogToConsole);
          this.documentLibrary = result.json();
          this.loaded = true;
        }, (error: HttpErrorResponse) => {
          this.handleError(error);
        });
      }, (error: HttpErrorResponse) => {
        this.handleError(error)
      });
    }), (error: HttpErrorResponse) => {
      this.handleError(error)
    });
  }

  handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. You appear to be offline.", "", { duration: 5000 });
        this.loggingService.log("Error - offline", this.appConfigService.LogToConsole);
        break;
      case 401:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. Your login has expired.", "", { duration: 5000 });
        this.loggingService.log("Error - login expired", this.appConfigService.LogToConsole);
        this.userSession.logout();
        break;
      case 500:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. Server error.", "", { duration: 5000 });
        this.loggingService.log("Error - Server error", this.appConfigService.LogToConsole);
      default:
        break;
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/views/portal-admin-patient-view/portal-admin-patient-view.component.ts